export enum AutofillComplementaryReportsDialogActions {
    OVERWRITE = 'OVERWRITE',
    CANCEL = 'CANCEL',
}
